<template>
    <div>
        <vx-card noShadow noRound>
            <h3>{{ po_id  ? 'Edit SAP PO' : 'Create SAP PO' }}</h3>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                    <vs-input
                        v-model="data.po_number"
                        label="PO Number"
                        class="w-full"
                        :disabled="submit_disabled"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.po_number">
                        {{ api_errors.po_number.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                    <SelectDate 
                        :selectedDate.sync="data.date" 
                        label="Date"
                        :disabled="submit_disabled"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.date">
                        {{ api_errors.date.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                    <InputSelect
                        :model.sync="data.status"
                        label="Status"
                        placeholder="select status"
                        container_class="w-auto input-custom-dropdown my-3"
                        :multiple="false"
                        :options="status_options"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.status">
                        {{ api_errors.status.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>

            <vs-row class="mt-base">
                <vs-col class="text-center">
                    <vs-button @click="save" :disabled="submit_disabled">
                        Save
                    </vs-button>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../utils/requests';

export default {
    data() {
        return {
            data: {
                po_number: null,
                date: null,
                status: "o",
            },
            original_data: null,

            status_options: [
                {value: 'i', label: "Inactive"},
                {value: 'a', label: "Active"}
            ],

            submit_disabled: false,
            api_errors: {},
        };
    },
    watch: {
        "$route.params.po_id"(newV, oldV) {
            if (newV == oldV || !newV) return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        po_id() {
            return this.$route.params.po_id;
        }
    },
    methods: {
        init() {
            if (this.po_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET'
            let url = this.$store.state.apiendpoints.sap_po + this.po_id + "/"

            this.$vs.loading()
            this.submit_disabled = true

            Request(this, request_method, url).then(
                res => {
                    this.data = res
                    this.original_data = JSON.parse(JSON.stringify(res))
                    this.$vs.loading.close()
                    this.submit_disabled = false
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {

            let request_method = 'POST' 
            let url = this.$store.state.apiendpoints.sap_po

            if (this.po_id) {
                request_method = 'PATCH'
                url += this.po_id + '/'
            }

            let payload = {}
            
            if (this.po_id && this.original_data) {

                Object.keys(this.data).forEach(key => {
                    let currentValue = this.data[key]
                    let originalValue = this.original_data[key]
                    
                    if (currentValue && originalValue && (key === 'date' || currentValue instanceof Date || originalValue instanceof Date)) {
                        currentValue = currentValue.toString()
                        originalValue = originalValue.toString()
                    }
                    
                    if (currentValue !== originalValue) {
                        payload[key] = this.data[key]
                    }
                })
            } else {
                payload = { ...this.data }
            }
            
            this.$vs.loading()
            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {

                    this.data = res
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })

                    this.$router.push({name: 'sap-po-list'})
                },
                err => {
                    this.submit_disabled = false
                    this.$vs.loading.close()

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        }
    }

};
</script>
